import { TCSearcherTimelineItemDocument as SearcherTimelineItemDocument } from 'src/api/generated';

/**
 * Extract numeric funnelId from a timeline item if present.
 */
export function getFunnelIdFromItem(
  item: SearcherTimelineItemDocument
): number | undefined {
  if (!item.funnelId) return undefined;

  const value = item.funnelId;
  if (!value) return undefined;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

/**
 * Extract numeric funnelConversationId from a timeline item if present.
 */
export function getConversationIdFromItem(
  item: SearcherTimelineItemDocument
): number | undefined {
  if (!item.funnelConversationId) return undefined;

  const value = item.funnelConversationId;
  if (!value) return undefined;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}
